module.exports = __webpack_public_path__ + "static/media/hero-works-three.b2858bfb.png";